import { colors } from '@material-ui/core'

const white = '#FFFFFF'
const black = '#000000'
const primaryMain = '#0A2540'
const primaryDark = '#051221'
const primaryLight = '#1E3A8A'
const secondary = '#0EA5E9'
const frostSlate = '#F1F5F9'

export const light = {
  type: 'light',
  black,
  white,
  primary: {
    contrastText: white,
    dark: primaryDark,
    main: primaryMain,
    light: primaryLight,
  },
  secondary: {
    contrastText: primaryMain,
    dark: '#0284C7',
    main: secondary,
    light: '#7DD3FC',
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[700],
    light: colors.green[400],
  },
  warning: {
    contrastText: white,
    dark: colors.orange[950],
    main: '#F4672C',
    light: colors.orange[400],
  },
  text: {
    primary: '#1e293b',
    secondary: '#475569',
    disabled: '#94a3b8',
  },
  background: {
    default: '#F8FAFC',
    paper: white,
    dark: '#f4f6f8',
  },
  backGroundItem: {
    card: '#FCFCFC',
    cardInterno: 'rgba(10, 37, 64, 0.025)', // Névoa Navy sutil idêntica aos detalhes do caso! 🧼✨
    tabelaHeaderFooter: primaryMain, // Nosso Midnight Navy Oficial (#0A2540) solicitado! 👑💙🚀
    tabelaHeaderFooterText: white, // Contraste branco garantido para fundo escuro no Claro! 🤍🧼
  },
  icon: '#64748b',
  divider: 'rgba(0,0,0,0.05)',
  // Centralização de Design Token para o TopBar
  topbarBackground: 'rgba(10, 37, 64, 0.9)', // Nosso Midnight Navy Premium
  topbarContrastText: '#FFFFFF',
}

export const dark = {
  type: 'dark',
  black,
  white,
  primary: {
    contrastText: white,
    dark: '#1D4ED8',
    main: '#3B82F6',
    light: '#60A5FA',
  },
  secondary: {
    contrastText: '#0A2540',
    dark: '#0284C7',
    main: secondary,
    light: '#7DD3FC',
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
  },
  success: {
    contrastText: '#0E0E0E',
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[300],
  },
  warning: {
    contrastText: '#0E0E0E',
    dark: colors.orange[900],
    main: '#F4672C',
    light: colors.orange[300],
  },
  text: {
    primary: '#E0E0E0',
    secondary: '#A0A0A0',
    disabled: '#666666',
  },
  background: {
    default: '#181818ff', // Fundo Absoluto Gemini Deep Dark
    paper: '#1E1F20', // Elevação Premium Gemini (Cards/Tabelas/Containers)
    dark: '#080808', // Base Subterrânea para Trilhos e Gavetas
  },
  backGroundItem: {
    card: '#1E1F20',
    cardInterno: '#2C2E33',
    tabelaHeaderFooter: '#2C2E33', // Mantém o elegante Slate Charcoal Claro invertido! 🌓💎🛸
    tabelaHeaderFooterText: '#E0E0E0', // Mantém a alta visibilidade via Texto Primário! 🛰️✨
  },
  icon: '#CCCCCC',
  divider: '#262626', // Linha de contraste refinada para o novo fundo
  // Centralização de Design Token para o TopBar (Modo Escuro Sóbrio e Integrado)
  topbarBackground: 'rgba(88, 113, 161, 0.95)', // Azul escuro mais aberto (combina perfeitamente com #181818ff)
  topbarContrastText: '#FFFFFF', // Contraste branco
}

export default light // Default para não quebrar imports antigoss
